import React from "react";
import PropTypes from "prop-types";
import Redirect from "utils/Redirect";
import LegalLinks from "components/v3/legal-links/LegalLinks";
import Newsletters from "containers/v3/NewslettersContainer";
import Header from "components/v3/header/Header";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import { BUTTON_THEME_WHITE } from "components/v3/primary-button/themes";
import styles from "./styles.module.scss";

const SignupNewsletters = ({ bloombergSiteUrl, email }) => {
    const onStartReading = () => {
        if (Redirect.hasRedirectCookie()) {
            Redirect.handleRedirect();

            return;
        }

        Redirect.redirectTo(bloombergSiteUrl);
    };

    const title = "Sign up for our newsletters";

    return (
        <div>
            <div className={ styles.banner }>
                <div className={ styles.bannerTitle }>
                    You&apos;re all set!
                </div>
                <div className={ styles.bannerButton }>
                    <PrimaryButton text="Start Reading" theme={ BUTTON_THEME_WHITE } onClick={ onStartReading } />
                </div>
            </div>
            <div className={ styles.newsletters }>
                <Header title={ title } />
                <div className={ styles.body }>
                    <Newsletters newsletterType="signup" email={ email } />
                    <LegalLinks bloombergSiteUrl={ bloombergSiteUrl } />
                </div>
            </div>
        </div>
    );
};

SignupNewsletters.propTypes = {
    bloombergSiteUrl: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired
};

export default SignupNewsletters;
